import { AppHelper } from "../appHelper.js"
import { AppBaseProps, CommonApp, Context } from "../core/components/commonApp.js";
import React from "react";

export class MigrationApp extends React.Component<MigrationAppProps, any> {
    common = new AppHelper();
    translations: {};

    constructor(props) {
        super(props);
        this.common.enableHooks = true;
        this.common.init(this);
        this.initApp();
    }

    private initApp = () => {
        this.props.context.translations = this.translations;
    }

    handleFieldChange = (field: { model: string }, value, dataItem = null, isInit = false) => {
        if (!isInit)
            this.common.handleFieldChange(field, value, dataItem);
    }



    render() {
        const props = $.extend({}, this.props, this.common.getHandlersForProps(this.props), { handleFieldChange: this.handleFieldChange });
        return <CommonApp {...props} />;
    }
};

export interface MigrationAppProps extends AppBaseProps {
    context: MigartionContext;
}

export interface MigartionContext extends Context {
    translations: {}
}
